/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wsc_trim_lines = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trim each line`)
};

const es_wsc_trim_lines = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recortar cada línea`)
};

const de_wsc_trim_lines = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Zeile trimmen`)
};

const nl_wsc_trim_lines = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elk regel bijsnijden`)
};

const fr_wsc_trim_lines = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les espaces de chaque ligne`)
};

const it_wsc_trim_lines = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taglia ogni riga`)
};

const pt_br2_wsc_trim_lines = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aparar cada linha`)
};

const pt_wsc_trim_lines = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aparar cada linha`)
};

const ja_wsc_trim_lines = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各行をトリム`)
};

const zh_wsc_trim_lines = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修剪每一行`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wsc_trim_lines = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wsc_trim_lines(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wsc_trim_lines", locale)
	if (locale === "en") return en_wsc_trim_lines(inputs)
	if (locale === "es") return es_wsc_trim_lines(inputs)
	if (locale === "de") return de_wsc_trim_lines(inputs)
	if (locale === "nl") return nl_wsc_trim_lines(inputs)
	if (locale === "fr") return fr_wsc_trim_lines(inputs)
	if (locale === "it") return it_wsc_trim_lines(inputs)
	if (locale === "pt-BR") return pt_br2_wsc_trim_lines(inputs)
	if (locale === "pt") return pt_wsc_trim_lines(inputs)
	if (locale === "ja") return ja_wsc_trim_lines(inputs)
	return zh_wsc_trim_lines(inputs)
};